<app-nav></app-nav>


<div class="container get-help">
  <div class="row">
    <div class="col-12 header-block">
      <h1>Get help now</h1>
      <p>
        If you are in a crisis or any other person may be in danger the following resources can
        provide you with immediate help.
      </p>
    </div>
  </div>
  <div class="row">
    <div class="d-none d-md-flex flex-column col-md-3 aside">
      <div class="sticky-top">
        <h3>
          Find a country
        </h3>
        <ul>
          <li>
            <a (click)="scrollTo('usa')">
              United States
            </a>
          </li>
          <li>
            <a (click)="scrollTo('uk')">
              UK & Republic of Ireland
            </a>
          </li>
          <li>
            <a (click)="scrollTo('ag')">
              Argentina</a>
          </li>
          <li>
            <a (click)="scrollTo('sp')">
              Spain</a>
          </li>
          <li>
            <a (click)="scrollTo('au')">
              Australia
            </a>
          </li>
          <li>
            <a (click)="scrollTo('cn')">
              China</a>
          </li>
          <li>
            <a (click)="scrollTo('ca')">
              Canada</a>
          </li>
          <li>
            <a (click)="scrollTo('sa')">
              South Africa</a>
          </li>
          <li>
            <a (click)="scrollTo('nz')">
              New Zealand</a>
          </li>
          <li>
            <a (click)="scrollTo('in')">
              India</a>
          </li>
          <li>
            <a (click)="scrollTo('de')">
              Germany</a>
          </li>
          <li>
            <a (click)="scrollTo('fi')">
              Finland</a>
          </li>

        </ul>
      </div>
    </div>
    <div class="col-12 col-md-9">
      <div class="mobile-filter row p-2">
        <select class="form-control" [(ngModel)]="option" (ngModelChange)="onOptionChange($event)">
          <option value="" disabled selected="true"><b>Find a country</b></option>

          <option value="usa">
            United States
          </option>
          <option value="uk">
            UK & Republic of Ireland
          </option>
          <option value="ag">
            Argentina
          </option>
          <option value="sp">
            Spain
          </option>
          <option value="au">
            Australia
          </option>
          <option value="cn">
            China
          </option>
          <option value="ca">
            Canada
          </option>
          <option value="sa">
            South Africa
          </option>
          <option value="nz">
            New Zealand
          </option>
          <option value="in">
            India
          </option>
          <option  value="de">
            Germany
          </option>
          <option value="fi">
            Finland
          </option>

        </select>
      </div>
      <div id="usa" class="item">
        <h3>United States</h3>
        <p><b>Emergency</b>:&nbsp;911</p>
        <p><b>Suicide & Crisis Lifeline</b>:&nbsp;Call or text 988</p>
        <p><b>National Domestic Violence Hotline</b>:&nbsp;1-800-799-7233</p>
        <p><b>Crisis Text Line</b>:&nbsp;Text "DESERVE" TO 741-741</p>
        <p><b>Lifeline Crisis Chat (Online live messaging)</b>:&nbsp;988lifeline.org/chat</p>
        <p><b>Self-Harm Hotline</b>:&nbsp;1-800-DONT CUT (1-800-366-8288)</p>
        <p><b>Essential local and community services</b>:&nbsp;211, www.211.org</p>
        <p><b>Planned Parenthood Hotline</b>:&nbsp;1-800-230-PLAN (7526)</p>
        <p><b>American Association of Poison Control Centers</b>:&nbsp;1-800-222-1222</p>
        <p><b>National Council on Alcoholism & Drug Dependency Hope Line</b>:&nbsp;1-800-622-2255
        </p>
        <p><b>National Crisis Line - Anorexia and Bulimia</b>:&nbsp;1-800-233-4357</p>
        <p><b>LGBT Hotline</b>:&nbsp;1-888-843-4564</p>
        <p><b>TREVOR Crisis Hotline</b>:&nbsp;1-866-488-7386</p>
        <p><b>AIDS Crisis Line</b>:&nbsp;1-800-221-7044</p>
        <p><b>Veterans Crisis Line</b>:&nbsp;www.veteranscrisisline.net</p>
        <p><b>TransLifeline</b>:&nbsp;www.translifeline.org - 877-565-8860</p>
      </div>

      <div id="uk" class="item">
        <h3>UK & Republic of Ireland</h3>
        <p><b>Emergency</b>:&nbsp;112 or 999</p>
        <p><b>Non-emergency</b>:&nbsp;111, Option 2</p>
        <p><b>24/7 Helpline</b>:&nbsp;116 123 (UK and ROI)</p>
        <p><b>Shout</b>:&nbsp;Text "DESERVE" TO 85258</p>
        <p><b>Samaritans.org</b>:&nbsp;samaritans.org/how-we-can-help-you/contact-us</p>
        <p><b>YourLifeCounts.org</b>:&nbsp;yourlifecounts.org/find-help</p>
      </div>


      <div id="ag" class="item">
        <h3>Argentina</h3>
        <p><b>Emergency</b>:&nbsp;911</p>
        <p>
          Recuerde siempre que si usted esta en una situación de emergencia debe comunicarse con los
          teléfonos: *107 (SAME-Sistema de Atención Medica de Emergencia), *911 (Emergencia
          policial), para atención telefónica inmediata. Si desea orientación telefónica a
          familiares y amigos, déjenos su mensaje y teléfono. Nos comunicaremos con usted.
        </p>
        <p><b>Argentina Suicide Hotline</b>:&nbsp;+5402234930430</p>
      </div>

      <div id="sp" class="item">
        <h3>Spain</h3>
        <p><b>Emergency</b>:&nbsp;112</p>
        <p>
          <b>Telefono De La Esperanza</b>:&nbsp; 717-003-717 — telefonodelaesperanza.org/llamanos
        </p>
      </div>

      <div id="au" class="item">
        <h3>Australia</h3>
        <p><b>Emergency</b>:&nbsp;000</p>
        <p><b>Lifeline.org </b>:&nbsp;lifeline.org.au/Get-Help/Online-Services/crisis-chat</p>
        <p><b>LifeLine Australia</b>:&nbsp;13 11 14</p>
        <p><b> YourLifeCounts.org</b>:&nbsp;yourlifecounts.org/find-help</p>
        <p><b>Beyond Blue</b>:&nbsp;beyondblue.org.au/get-support/get-immediate-support</p>
      </div>


      <div id="cn" class="item">
        <h3>China</h3>
        <p><b>Emergency</b>:&nbsp;110</p>
        <p>
          <b>Beijing Suicide Research and Prevention Center</b>:&nbsp; http://www.crisis.org.cn/
          800-810-1117 (landline) or 010-8295-1332 (mobile and VoIP callers)
        </p>
        <p>
          <b>Shanghai Mental Health Center</b>:&nbsp;http://www.smhc.org.cn
        </p>
        <p>
          <b>Lifeline Shanghai</b>:&nbsp;https://www.lifeline-shanghai.com
        </p>
      </div>


      <div id="ca" class="item">
        <h3>Canada</h3>
        <p><b>Emergency</b>:&nbsp;991</p>
        <p>
          <b>Crisis Text Line (Powered by Kids Help Phone)</b>:&nbsp; Text "DESERVE" TO 686868
        </p>
        <p>
          <b>YourLifeCounts.org</b>:&nbsp;yourlifecounts.org/find-help
        </p>
        <p>
          <b>Crisis Services Canada</b>:&nbsp;crisisservicescanada.ca/en
        </p>
        <p>
          <b>Canadian Association for Suicide Prevention</b>:&nbsp;suicideprevention.ca/need-help
        </p>
      </div>

      <div id="sa" class="item">
        <h3>South Africa
        </h3>
        <p><b>Emergency</b>:&nbsp;10 111 for police or 10 177 for an ambulance</p>
        <p>
          <b>24hr Helpline</b>:&nbsp;0800 12 13 14 or SMS 31393 (and we will call you back)
        </p>
        <p>
          <b>Depression and Anxiety Helpline</b>:&nbsp;0800 70 80 90
        </p>
        <p>
          <b>YourLifeCounts.org</b>:&nbsp;yourlifecounts.org/find-help
        </p>
      </div>

      <div id="nz" class="item">
        <h3>New Zealand
        </h3>
        <p><b>Emergency</b>:&nbsp;111</p>
        <p><b>Lifeline 24/7 Helpline</b>:&nbsp;0800 543 354</p>
        <p><b>Suicide Crisis Helpline</b>:&nbsp;0508 828 865 (0508 TAUTOKO)</p>
        <p><b>YourLifeCounts.org</b>:&nbsp;yourlifecounts.org/find-help</p>

      </div>

      <div id="in" class="item">
        <h3>India
        </h3>
        <p><b>Emergency</b>:&nbsp;112</p>
        <p><b>Sneha India</b>:&nbsp;(www.snehaindia.org) is available 24/7 on the phone by calling
          91 44 24640050</p>
        <p><b>Suicide Crisis Helpline</b>:&nbsp;0508 828 865 (0508 TAUTOKO)</p>
      </div>

      <div id="de" class="item">
        <h3>Germany
        </h3>
        <p><b>Emergency</b>:&nbsp;112</p>
        <p><b>Hotline</b>:&nbsp;800 111 0111</p>
        <p><b>Hotline</b>:&nbsp;0800 111 0222</p>
      </div>


      <div id="fi" class="item">
        <h3>Finland
        </h3>
        <p><b>Emergency</b>:&nbsp;112</p>
        <p><b>Crisis Line</b>:&nbsp;010 195 202</p>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
